var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcPhoneBinline = function SvgIcPhoneBinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.202 1.253a1.84 1.84 0 00-1.84 1.84v25.814a1.84 1.84 0 001.84 1.84h11.596a1.84 1.84 0 001.84-1.84V3.093a1.84 1.84 0 00-1.84-1.84H10.202zm-3.013 1.84A3.013 3.013 0 0110.202.08h11.596a3.013 3.013 0 013.013 3.013v25.814a3.013 3.013 0 01-3.013 3.013H10.202a3.013 3.013 0 01-3.013-3.013V3.093zm6.256.429c0-.324.262-.587.586-.587h3.937a.587.587 0 010 1.174h-3.937a.587.587 0 01-.586-.587zM16 26.502a.817.817 0 100 1.633.817.817 0 000-1.633zm-1.99.817a1.99 1.99 0 113.98 0 1.99 1.99 0 01-3.98 0z",
    fill: "#121E6C"
  })));
};
export default SvgIcPhoneBinline;